import { ListHeaderContainer, HeaderActions } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Typography } from '../../foundation/Typography/styled.js';

function ListHeader(props) {
  var title = props.title,
    actions = props.actions,
    children = props.children,
    className = props.className,
    _props$sticky = props.sticky,
    sticky = _props$sticky === void 0 ? false : _props$sticky;
  return /*#__PURE__*/jsxs(ListHeaderContainer, {
    $sticky: sticky,
    className: className,
    children: [title && /*#__PURE__*/jsx(Typography, {
      $fontSize: "small",
      $appearance: "100",
      $fontWeight: "bold",
      children: title
    }), children, actions && /*#__PURE__*/jsx(HeaderActions, {
      children: actions
    })]
  });
}

export { ListHeader };
